<template>
  <div ref="form" class="z-card" autocomplete="off">
    <div class="flex flex--baseline flex-row-between">
      <h4>{{ $t('core.profile.block.change_password.title') }}</h4>

      <div class="link" @click="toggle_view">
        {{ change_password_by_current_password ? `${$t('core.reset_password.change_by.email')}` : `${$t('core.reset_password.change_by.password')}` }}
      </div>
    </div>
    <form-password v-if="change_password_by_current_password" />
    <form-email v-else />
  </div>
</template>

<script>
  import FormPassword from '@core/components/profile/profile-change-password-form-by-password'
  import FormEmail from '@core/components/profile/profile-change-password-form-by-email'
  import Conditions from '@shared/components/reset-password-form/conditions';
  import IconSuffix from '@core/components/auth/reset-password/icon-suffix';

  export default {
    components: { FormPassword, FormEmail },
    data: () => ({
      change_password_by_current_password: true,
    }),
    methods: {
      toggle_view() {
        this.change_password_by_current_password = !this.change_password_by_current_password;
      },
    }
  };
</script>
